module.exports = __webpack_public_path__ + "media/images/official/special_double_life_point_people-0040e265ca8a26a08e6565665258b310.jpg";